import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/database";
import "firebase/compat/storage";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCMAs8cyM68K1JfVseIjU_nNgEeyXBxL-s",
  authDomain: "financefrenzy-biz.firebaseapp.com",
  projectId: "financefrenzy-biz",
  storageBucket: "financefrenzy-biz.appspot.com",
  messagingSenderId: "580011627408",
  appId: "1:580011627408:web:99c50c6393cff1ae995915",
  measurementId: "G-4XFKVM6685",
};
 // Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Initialize Firebase if not already initialized
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.app(); // Use the already initialized app
}

// Export Firestore instance
export const db = firebase.firestore();
export default firebase;

 
